import { render, staticRenderFns } from "./UsersTagsList.vue?vue&type=template&id=1c9e2d93&scoped=true&"
import script from "./UsersTagsList.vue?vue&type=script&lang=js&"
export * from "./UsersTagsList.vue?vue&type=script&lang=js&"
import style0 from "./UsersTagsList.vue?vue&type=style&index=0&id=1c9e2d93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9e2d93",
  null
  
)

export default component.exports